import { Suspense } from 'react'
import { PageLoader } from '@/components/common/PageLoader'
import AppRoutes from '@/router/routes'

export default function App() {
	return (
		<Suspense fallback={<PageLoader />}>
			<AppRoutes />
		</Suspense>
	)
}
